// extracted by mini-css-extract-plugin
module.exports = {"Position":"index-module_Position_1W_sP"};